import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import bootstrap from '../assets/bootstrap.png';
import express from '../assets/express.png';
import keras from '../assets/keras.png';
import mongo from '../assets/mongo.png';
import sql from '../assets/sql.png';
import tensorflow from '../assets/tensorflow.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import github from '../assets/github.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import about001 from '../assets/about001.jpeg';
import about002 from '../assets/about002.jpeg';
import about003 from '../assets/about003.jpeg';
import about004 from '../assets/about004.jpeg';
import about005 from '../assets/about005.png';

import profile from '../assets/profile.png';
import profileAbout from '../assets/profileAbout.jpg';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

export const logos = {
    email,
    mobile,
    api,
    bootstrap,
    express,
    keras,
    mongo,
    sql,
    github,
    tensorflow,
    cpp,
    css,
    figma,
    flutter,
    git,
    graphql,
    html,
    javascript,
    mu5,
    node,
    python,
    react,
    redux,
    sass,
    typescript,
    vue,
    about01,
    about02,
    about03,
    about04,
    about001,
    about002,
    about003,
    about004,
    about005,
    profile,
    profileAbout,
    circle,
    logo,
    adidas,
    amazon,
    asus,
    bolt,
    nb,
    skype,
    spotify,
};